export const defaultValues = {
  firstName: null,
  secondName: null,
  surname: null,
  secondSurname: null,
  documentType: null,
  documentNumber: null,
  charge: null,
  duration: null,
  contractType: null,
  initDate: null,
  endDate: null,
  remuner: null,
  regional: null,
  licenseInitDate: null,
  licenseFinishDate: null,
  possibleDueDate: null,
  startDatePregnancy: null
};